import { useEffect, useState } from "react";
import { getDuration, getDurationString } from "~/lib/date";

interface NodeDurationProps {
  startedAt?: string | null;
  finishedAt?: string | null;
}

/**
 * Renders a step duration for canvas nodes with a placeholder when the step hasn't started yet.
 *
 * Uses a simple interval instead of Duration.Short, which relies on IntersectionObserver
 * for ticking. IntersectionObserver can misfire inside ReactFlow's transformed canvas,
 * preventing the duration from updating for running steps.
 */
export function NodeDuration({ startedAt, finishedAt }: NodeDurationProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!startedAt || finishedAt) {
      return;
    }

    const interval = setInterval(() => setTick((tick) => tick + 1), 1000);
    return () => clearInterval(interval);
  }, [startedAt, finishedAt]);

  const seconds = startedAt ? getDuration(startedAt, finishedAt ?? undefined).asSeconds() : 0;

  return startedAt ? (
    <>{getDurationString(seconds, "short")}</>
  ) : (
    <span aria-hidden="true">--</span>
  );
}
